import { render, staticRenderFns } from "./ViewRPurchase.vue?vue&type=template&id=7c392bb3"
import script from "./ViewRPurchase.vue?vue&type=script&lang=js"
export * from "./ViewRPurchase.vue?vue&type=script&lang=js"
import style0 from "./ViewRPurchase.vue?vue&type=style&index=0&id=7c392bb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports